<template>
  <div class="paper-wrap"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="paperList">
      <template v-if="paperList.length">
        <div class="header">
          <span class="label">选择批次：</span>
          <el-select v-model="batchId" size="mini">
            <el-option v-for="batch in paperList" :key="batch.id" :label="batch.name" :value="batch.id"></el-option>
          </el-select>
        </div>
        <div class="cont">
          <slot v-bind="panelParams"></slot>
        </div>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>暂无批次</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading" type="error">
        <div>{{ errorMsg || '获取批次列表失败' }}</div>
        <el-button type="text" @click="loadData">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../elements/Hint.vue'
export default {
  name: 'PaperWrap',
  components: {
    Hint
  },
  props: {
    fetchUrl: {
      type: String,
      default: '/workspace/manager/paper/choice/queryPaperList'
    }
  },
  data () {
    return {
      batchId: '',
      paperList: null,
      loading: false,
      errorMsg: ''
    }
  },
  computed: {
    panelParams () {
      return {
        paperBatchId: this.batchId
      }
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: this.fetchUrl
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.paperList = response.data.paperList || []
        } else {
          this.errorMsg = response.data.message || '获取批次列表失败'
        }
      }, () => {
        this.errorMsg = '获取批次列表失败'
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    paperList: function (val) {
      if (val && val.length) {
        this.batchId = val[0].id
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paper-wrap{
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  & > .header{
    padding: 20px 20px 10px;
    font-size: 12px;
  }
  & > .cont{
    flex: 1;
    height: 0;
  }
}
</style>
